import Image from "next/image";
import { ReactNode } from "react";

interface Props {
  icon?: string;
  title: ReactNode;
  description: ReactNode;
  footer?: ReactNode;
}

const StatusPage = ({ icon, title, description, footer }: Props) => {
  return (
    <div className="mx-auto max-w-[640px] px-6">
      <div className="mt-[23.68dvh] flex flex-col items-center gap-8">
        {icon && <Image src={icon} alt="" width={160} height={160} />}
        <div className="flex flex-col gap-4 text-center">
          <span className="text-xl font-semibold">{title}</span>
          <span className="text-content-secondary text-sm">{description}</span>
          {footer}
        </div>
      </div>
    </div>
  );
};

export default StatusPage;
